/*jshint esversion: 6 */


import {getQuizStartTime, getTimelimitInMs, getRemainingTime} from "../selectors/quizSelectors";

// Bit states
export const QUIZ_LOADED = 1;



export const LOAD_NEXT_QUESTION = 2;
export const QUIZ_STARTED = 4;
export const TIME_IS_UP = 8;
export const TIMER_TICK = 16;
export const QUESTIONS_RECEIVED = 32;
export const QUIZ_COMPLETE = 64;
export const RANDOM_ERROR = 128;
export const REQUIRE_AUTH = 256;

export const ADD_STATE = 'add_state';



export const addState = (data, state, type) => (
    {
        state: state,
        type: state,
        data: data,
    }
);


export const requireAuth = (title, content) => ({
    type: REQUIRE_AUTH,
    title: title,
    body: content
});

export const randomError = (title, content) => ({
    type: RANDOM_ERROR,
    title: title,
    body: content
});


// Quiz started
export const startQuiz = (question, startDate, timeLeft) => ({
    type: QUIZ_STARTED,
    payload: { timeStart: Date.now(), question, startDate, timeLeft: parseInt(timeLeft,10) * 60 * 100}
});



/* When any question has been loaded */
export const questionLoaded = question => ({
    type: QUESTIONS_RECEIVED,
    question: question
});

/* When all question have been answered */
export const quizComplete = () => ({
        type: QUIZ_COMPLETE,
});

export const quizVerified = (data) => ({
    type: QUIZ_LOADED,
    state: QUIZ_LOADED,
    quiz: data,
});

export const tick = (state) => ({
    type: TIMER_TICK,
    payload: { timeLeft: getRemainingTime(state)}
});


















